module.exports = __webpack_public_path__ + "img/Lineups.a1028512.png";